import Media from './../mediaDetect.js'; //Детектор медиа
import Tabs from './tabs.js';
import TableScroll from './table-scroll.js';

$(document).ready(function ($) {

    // accordion panel
    $('.main').on('click', '[data-accordion-toogle]', function (event, state) {

        var $accordionToogle = $(this),
            $accordion = $accordionToogle.closest('[data-accordion]'),
            $accordionContent = $accordionToogle.next('[data-accordion-content]');

            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp(400);
            } else {
                $accordionContent.slideDown(400, function () {
                    $accordion.addClass('open');

                    var sliderInnerAccordion = $accordionContent.find('[data-typical-slider]');
                    if(sliderInnerAccordion.length && sliderInnerAccordion.hasClass('slick-initialized')) {
                        sliderInnerAccordion.slick('refresh');
                    }
                });
            }

            var tabsWrapAccordion = $accordionContent.closest('[data-tabs]');
            if(tabsWrapAccordion.length && Media.detect().isMobile) {
                setTimeout(function(){
                    Tabs.updateTabs(tabsWrapAccordion);
                }, 400);
            }

            var table = $accordionContent.find('[data-scroll-index]');
            if(table.length && !$accordion.hasClass('open')) {
                TableScroll.updateContent(table.data('scroll-index'));
            }
    });
    // /accordion

    function setCookie(name, value, options) {
        options = options || {};

        var expires = options.expires;

        if (typeof expires == "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
            updatedCookie += "; " + propName;
            var propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }

        document.cookie = updatedCookie;
    }

});


$(window).on('load', function() {
    var hash = window.location.hash.substring(1);

    if (hash != '' && $('[data-accordion-id="' + hash + '"]').length){

        var selectAccordion = $('.accordion').find(('[data-accordion-id="' + hash + '"]')),
            typeTab = selectAccordion.closest('[data-tab-panel]').data('tab-panel-type'),
            selectTab,
            selectPanel;

        // если есть тип таба, открываем нужный
        if (typeTab != ''){
            selectTab = $('.tabs').find('[data-tab-link-type="' + typeTab + '"]'),
            selectPanel = $('.tabs__container').find('[data-tab-panel-type="' + typeTab + '"]');

            if(!selectTab.hasClass('active')){
                $('.tabs').find('[data-tab-link]').removeClass('active');
                selectTab.addClass('active');
            }

            if(!selectPanel.hasClass('active')){
                $('.tabs__container').find('[data-tab-panel]').removeClass('active');
                selectPanel.addClass('active');
            }
        }

        // скроллим к аккордеону по hash, открываем все внутренние подпункты
        setTimeout(function(){
            let resultScroll = selectAccordion.offset().top + 1 - $('[data-header-bottom]').outerHeight();

            $('html, body').animate({scrollTop: resultScroll}, 500);

            var $accordion = selectAccordion,
                $accordionToogle = $accordion.find('[data-accordion-toogle]'),
                $accordionContent = $accordionToogle.next('[data-accordion-content]');

            $accordionContent.slideDown(400, function () {
                $accordion.addClass('open');

                var sliderInnerAccordion = $accordionContent.find('[data-typical-slider]');
                if(sliderInnerAccordion.length && sliderInnerAccordion.hasClass('slick-initialized')) {
                    sliderInnerAccordion.slick('refresh');
                }
            });
        }, 200);

    }
});


// WEBPACK FOOTER //
// ./components/accordion.js